import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
    Message,
    List
} from 'semantic-ui-react';
import Alert from "../../components/extras/Alert";

import connect from "react-redux/es/connect/connect";
import {comboDialog} from "../../actions/ComboDialogActions";
import CustomDivider from "../extras/CustomDivider";
import localDB from "../../data/localDB";
import ComboData from "../../data/ComboData";
import Loading from "../extras/Loading";
import ComboItem from "./ComboItem";
import {addCombo, listCombo} from "../../actions/ComboActions";
import {showToast} from "../../actions/ToastAction";

class ProductComboDialog extends Component {

    constructor() {
        super();

        this.state = {
            options: [],
            additional_error: false,
            quantity_error: false,
            data:{
                additional:null,
                quantity:'',
            },
            loading: true,
            loading_add:false,
            id: null,
            height: 80
        };
        this.loadData = this.loadData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.id && nextProps.modal.id !== this.state.id){
            this.setState({loading:true, id: nextProps.modal.id});
            this.initialFetch(nextProps.modal.id);
        }
        if(nextProps.modal.is_open){
            this.loadData();
        }
    }

    componentDidMount(){
        this.loadData();
    };

    async initialFetch(id) {
        let products = await ComboData.list(id);
        let height = products.length > 0 ? 200:80;
        this.setState({loading: false, height});
        this.props.listCombo(products);
    }

    loadData() {
        localDB.getDB('products').then(products => {
            let options = products.filter(product => {return product.id !== this.props.modal.id}).map(product => {return {key:product.id, value:product.id, text:product.name}});
            this.setState({options});
        });
    };

    handleClose = () => {
        this.setState({
            id: null,
            loading: false,
        });
        this.props.comboDialog({
            is_open:false,
            loading:false,
            name:null,
            id:null
        });
        this.props.listCombo([]);
    };

    handleChange = (e, { name, value }) => {
        let data = this.state.data;
        data[name]= value;
        this.setState({data, additional_error:false, quantity_error:false});
    };

    async handleSubmit() {
        if(this.state.data.additional === null){
            this.setState({additional_error:true});
        }else if(this.state.data.quantity <= 0){
            this.setState({quantity_error:true});
        }else {
            let data = this.state.data;
            data.product = this.state.id;
            this.add(data);
        }
    };

    async add(data) {
        this.setState({loading_add:true});
        ComboData.add(data, (res) => {
            if (res.save) {
                this.props.addCombo(res.data);
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Este producto ya está en la lista!'
                });
            }
            this.setState({loading_add:false});
        });
    };

    render() {
        let listItems = this.props.product_combo.map(function (product) {
            return (
                <ComboItem {...product} key={product.id}/>
            )
        }, this);

        let data = (this.props.product_combo.length > 0 ? listItems :
                <Message icon='bell' header='No hay información registrada'/>
        );

        return (
            <div>
                <Modal open={this.props.modal.is_open} dimmer='inverted' size='tiny' onClose={this.handleClose}>
                    <Modal.Header>{`Combo - ${this.props.modal.name}`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group>
                                    <Form.Dropdown
                                        options={this.state.options}
                                        placeholder='Producto'
                                        name='additional'
                                        onChange={this.handleChange}
                                        search
                                        selection
                                        width={8}
                                        error={this.state.additional_error}
                                    />
                                    <Form.Input
                                        placeholder='Cant.'
                                        type='number'
                                        name='quantity'
                                        min={0}
                                        width={4}
                                        value={this.state.data.quantity}
                                        onChange={this.handleChange}
                                        error={this.state.quantity_error}
                                    />
                                    <Form.Button
                                        circular
                                        icon='add'
                                        primary
                                        disabled={this.state.loading_add}
                                        loading={this.state.loading_add}
                                        width={2}
                                    />
                                </Form.Group>
                            </Form>
                            <CustomDivider/>
                            <div className='modal-content-scroll' style={{height:this.state.height}}>
                                <List divided verticalAlign='middle'>
                                    {this.state.loading ? <Loading /> : data}
                                </List>
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <Alert ref='alert'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        comboDialog(modal) {
            dispatch(comboDialog(modal))
        },
        listCombo(data){
            dispatch(listCombo(data))
        },
        addCombo(data){
            dispatch(addCombo(data))
        },
        showToast(alert) {
            dispatch(showToast(alert));
        },
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('combo_dialog'),
        product_combo: state.get('combo'),
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductComboDialog)


// WEBPACK FOOTER //
// ./src/components/inventories/ProductComboDialog.js